import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { AppTitleService } from '../../services/app-title.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ListadoDocumentoPaginado, Documento } from '../../models/Document';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentoService } from '../../services/documento.service';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { FilterData } from '../borrador/borrador.component';
import { DocumentType } from '../../models/DocumentType';
import { merge, startWith, switchMap, catchError, EMPTY, map } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { EstadosDocumentoComponent } from "../../commons/estados-documento/estados-documento.component";
import { ReportService } from '../../services/report.service';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../commons/dlg-confirm/dlg-confirm.component';
import { TareaService } from '../../services/tarea.service';
import { DlgAlertComponent } from '../../commons/dlg-alert/dlg-alert.component';
import { CustomPaginator } from '../../commons/custom-paginator/custom-paginator';
import { NoDataFoundComponent } from "../../commons/no-data-found/no-data-found.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AutofocusDirective } from '../../helpers/autofocus.directive';
import { DlgReporteComponent } from '../../commons/dlg-reporte/dlg-reporte.component';

@Component({
  selector: 'app-enviado',
  imports: [
    MatTableModule, MatPaginatorModule, MatSortModule,
    MatSnackBarModule,
    MatToolbarModule, MatButtonModule, MatIconModule,
    MatInputModule, MatFormFieldModule,
    FormsModule, ReactiveFormsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTooltipModule, AutofocusDirective,
    MatProgressSpinnerModule,
    EstadosDocumentoComponent, MatProgressBarModule,
    NoDataFoundComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './enviado.component.html',
  styleUrl: './enviado.component.scss'
})
export class EnviadoComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['select', 'movimiento', 'estados', 'asunto', 'fecha', 'numeroDocumento'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = true;

  documentTypes: DocumentType[] | undefined

  dateRangeInWeeks = 5
  initialDate = "2025-01-02"
  maxDate = new Date()

  snackbarData: ScnackbarData = {}

  tipoBandeja = "2"

  filterForm = new FormGroup({
    fechaInicio: new FormControl(new Date(), {
      validators: [
        Validators.required
      ]
    }),
    fechaFin: new FormControl(new Date(), {
      validators: [
        Validators.required,
      ]
    }),
    searchText: new FormControl(""),
    numero: new FormControl('', [Validators.pattern('^(?:\\d{4}-)?\\d+$')]),
    documentType: new FormControl("")
  })

  constructor(
    private documentoSrv: DocumentoService,
    private documentTypeService: DocumentTypeService,
    private router: Router,
    public dialog: MatDialog,
    private toast: ToastService,
    private tareaService: TareaService,
    private reportService: ReportService,
    private dateService: DateService,
    public dlg: MatDialog,
  ) {
    inject(AppTitleService).setTitle('Enviados');
  }

  ngOnInit(): void {
    const currentDate = new Date()
    let initialDate = new Date(this.initialDate)
    //initialDate.setDate(currentDate.getDate() - this.dateRangeInWeeks * 7)
    this.filterForm.controls.fechaFin.setValue(currentDate)
    this.filterForm.controls.fechaInicio.setValue(initialDate)
  }

  ngAfterViewInit(): void {

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    this.documentTypeService.list().subscribe({
      next: (response) => {
        this.documentTypes = response as DocumentType[]
        let documentTypeDescription = "Oficio"

        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);

        if (defaultType) {
          this.filterForm.controls.documentType.setValue("-1")

          merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
            switchMap(() => {
              this.isLoadingResults = true;
              const filterData = this.createFilterData()
              return this.documentoSrv!.getListadoDocumentosBandeja(
                this.tipoBandeja,
                filterData.initialDate,
                filterData.endDate,
                filterData.searchText,
                filterData.documentType,
                null,
                "",
                this.paginator.pageIndex + 1,
              ).pipe(catchError(() => EMPTY));
            }),
            map(data => {
              this.isLoadingResults = false;
              if (data === null) {
                return [];
              }
              this.resultsLength = data.totalDocumentos;
              return data;
            })
          ).subscribe({
            next: (response) => {
              this.documentsPaginated = response as ListadoDocumentoPaginado
              this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
              Object.keys(this.filterForm.controls).forEach(controlName => {
                if (controlName !== "searchText" && controlName !== "numero") {
                  this.filterForm.get(controlName)?.valueChanges.subscribe(_ => {
                    this.reload();
                  });
                }
              });
            }
          })
        }
      }
    });
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.reload();
  }

  onClear(): void {
    this.filterForm.controls.searchText.setValue("")
    this.reload()
  }

  reload() {
    this.filterForm.controls.numero.setValue("");
    this.selection.clear()
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  onKeyUpFlow(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.buscarFlow();
  }

  buscarFlow() {
    this.filterForm.controls.searchText.setValue("")
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  fectchAndInitializeDataSource() {
    this.paginator.pageIndex = 0
    const filterData = this.createFilterData()
    this.isLoadingResults = true;
    this.documentoSrv!.getListadoDocumentosBandeja(
      this.tipoBandeja,
      filterData.initialDate,
      filterData.endDate,
      filterData.searchText,
      filterData.documentType,
      null,
      filterData.numero ? filterData.numero : null,
      this.paginator.pageIndex + 1,
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response as ListadoDocumentoPaginado
        this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
        this.resultsLength = this.documentsPaginated.totalDocumentos;
        this.isLoadingResults = false;
      }
    })
  }

  private createFilterData(): FilterData {
    const filterData: FilterData = {
      initialDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!),
      endDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!),
      documentType: parseInt(this.filterForm.controls.documentType.value!),
      numero: this.filterForm.controls.numero.value?.toString() ?? undefined,
      searchText: this.filterForm.controls.searchText.value!
    }
    return filterData
  }

  reAsign() {
  }

  archivar() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("/documento/archivar", { state: taskData })
  }

  onAddComment() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("comentar", { state: taskData })
  }

  onUnprint() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const printed = this.selection.selected.filter(document => document.impresa === 1)
    if (printed.length === 0) {
      this.snackbarData.message = "Las tareas seleccionadas no tienen el estado \"Hoja gu\xeda impresa\""
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: printed.map(document => document.idTarea)
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "50vw",
      width: "450px",
      data: {
        title: "Hoja gu\xeda",
        message: "¿Desea cambiar el estado a \"No impreso\" de los documentos seleccionados?",
        confirmLabel: "S\xed, cambiar",
        closeLabel: "No"
      }
    })
    const ids = taskData.documentIDs.join(",")
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.tareaService.updateEstadoTareasHojaGuia(0, ids).subscribe({
          next: (res: any) => {
            this.snackbarData.message = "Cambio de estado a \"No impreso\" exitoso"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "success"
            this.toast.show(this.snackbarData)
            this.reload()
          }
        })
      }
    })
  }

  onReporte() {
    let dialogRef = this.dialog.open(DlgReporteComponent, {
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  onHojaGuia() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.title = "Hoja gu\xeda"
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }

    const unprinted = this.selection.selected.filter(document => document.impresa === 0)
    if (unprinted.length === 0) {
      this.snackbarData.message = "Documentos seleccionados tienen el estado \"Hoja gu\xeda impresa\""
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }

    const tareasIDs = unprinted.map(document => document.idTarea);
    var tareas: any = [];
    tareasIDs.forEach((id) => {
      tareas.push({
        id: id,
        comentario: null,
        idParticipante: null,
        fechaExpira: null,
      });
    })

    const taskData = {
      documentIDs: unprinted.map(document => document.idTarea)
    }

    this.tareaService.getHojaGuia(tareas, 1).subscribe({
      next: (res: any) => {
        if (res) {
          res.fi = this.dateService.formatDateToCustomStringNoTime(this.filterForm.controls.fechaInicio.value!)
          res.ff = this.dateService.formatDateToCustomStringNoTime(this.filterForm.controls.fechaFin.value!)
          res.usr = res.user
          if (res.ids.length > 0) {
            this.onCallReport(res);
            this.onCambiarEstadoImpresoConfirm({ ids: taskData.documentIDs.join(",") })
          } else {
            this.snackbarData.message = "No dispone de documentos para impresi\xf3n"
            this.snackbarData.style = SnackbarStyles.Info
            this.snackbarData.iconName = "info"
            this.toast.show(this.snackbarData)
          }
        }
      }
    })
  }

  onCallReport(obj: any) {
    //https://127.0.0.1:8443/dfwreportes/rs/rpt/listadotipodocumento?P_CODIGO_TIPO_DOC=3
    var params = {
      P_USUARIO: obj.usr,
      P_DEPARTAMENTO: obj.dpto,
      P_FECHA_INICIO: obj.fi,
      P_FECHA_FIN: obj.ff,
      P_CODIGOS: obj.ids
    }
    var url: any = this.reportService.getUrl("rpListadoHojaGuia", params);
    this.reportService.openReport(url as string, 'Listado_hoja_guia_enviados.pdf');
  }

  onCambiarEstadoImpresoConfirm(obj: any) {

    const data: DlgConfirmComponentData = {
      title: "Hoja gu\xeda",
      message: "¿Desea cambiar el estado impreso de los documentos impresos?",
      confirmLabel: "Si, cambiar",
      closeLabel: "No"
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.tareaService.updateEstadoTareasHojaGuia(1, obj.ids).subscribe({
          next: (res: any) => {
            this.snackbarData.title = "Hoja gu\xeda"
            this.snackbarData.message = "Estado impreso actualizado"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "success"
            this.toast.show(this.snackbarData)
            this.reload()
          }
        })
      }
    });
  }


  clickedRow(row: Documento) {
    this.router.navigateByUrl("/resumen/" + row.idTarea)
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data);
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDateNoTime(date)
  }

}
